// * MUI Components
import { Box, Container, Typography, styled, Card, CardContent } from "@mui/material";
import { Savings, PriorityHigh, Replay, AccountBalance } from "@mui/icons-material";
import ShapeBackground from "./fancy/ShapeBackground";

// * Styled Components
const PropertiesBox = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  gap: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
  },
}));

const PropertiesTextBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
  },
}));

const FeatureCard = styled(Card)(({ theme }) => ({
  borderRadius: 12,
  padding: theme.spacing(3),
  boxShadow: "0px 4px 20px rgba(51, 112, 255, 0.08)",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "translateY(-8px)",
    boxShadow: "0px 8px 30px rgba(51, 112, 255, 0.15)",
  },
}));

const features = [
  {
    id: 1,
    icon: <Savings sx={{ fontSize: 50, color: "#3370FF" }} />,
    title: "Automated Rules",
    description: "Move $20 to savings every time you dine out.",
    bgColor: "#E6F0FF",
  },
  {
    id: 2,
    icon: <PriorityHigh sx={{ fontSize: 50, color: "#FF6B3D" }} />,
    title: "Overspending Penalties",
    description: "Spent too much on Amazon? Auto-transfer $15 to a penalty jar.",
    bgColor: "#FFE9E3",
  },
  {
    id: 3,
    icon: <Replay sx={{ fontSize: 50, color: "#4318FF" }} />,
    title: "Roundups on Steroids",
    description: "Round up, save, redirect, categorize, and stack rules.",
    bgColor: "#F0E9FF",
  },
  {
    id: 4,
    icon: <AccountBalance sx={{ fontSize: 50, color: "#3370FF" }} />,
    title: "Real-Time Triggers",
    description: "When you get paid → split your paycheck into buckets.",
    bgColor: "#E6F0FF",
  },
];

export default function Properties() {
  return (
    <Box sx={{ mt: 5, position: "relative", overflow: "hidden", py: 10 }}>
      <ShapeBackground />
      <Container sx={{ position: "relative", zIndex: 1 }}>
        <PropertiesTextBox>
          <Typography
            sx={{ color: "#2B3674", fontSize: "35px", fontWeight: "bold", mb: 2 }}
          >
            Features Preview
          </Typography>
          <Typography sx={{ color: "#4A5568", fontSize: "16px", my: 3 }}>
            Powerful automation tools to keep your finances on track
          </Typography>
        </PropertiesTextBox>

        <PropertiesBox>
          {features.map((feature) => (
            <FeatureCard key={feature.id}>
              <CardContent>
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    backgroundColor: feature.bgColor,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 3,
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#2B3674",
                    mb: 2,
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    color: "#4A5568",
                    lineHeight: 1.8,
                  }}
                >
                  {feature.description}
                </Typography>
              </CardContent>
            </FeatureCard>
          ))}
        </PropertiesBox>
      </Container>
    </Box>
  );
}
